const DEVICE_BUTTON_TYPE = {
  inBasket: 'inBasket',
  preOrder: 'preOrder',
  toBasket: 'toBasket',
  outOfStock: 'outOfStock',
  outOfStockSent: 'outOfStockSent',
};

const DEVICE_BUTTON_VARIANT = {
  [DEVICE_BUTTON_TYPE.inBasket]: 'secondary',
  [DEVICE_BUTTON_TYPE.preOrder]: 'tertiary',
  [DEVICE_BUTTON_TYPE.toBasket]: 'tertiary',
  [DEVICE_BUTTON_TYPE.outOfStock]: 'tertiary',
  [DEVICE_BUTTON_TYPE.outOfStockSent]: 'tertiary',
};

const DEVICE_BUTTON_CAPTION = {
  [DEVICE_BUTTON_TYPE.inBasket]: 'В корзине',
  [DEVICE_BUTTON_TYPE.preOrder]: 'Предзаказ',
  [DEVICE_BUTTON_TYPE.toBasket]: 'В корзину',
  [DEVICE_BUTTON_TYPE.outOfStock]: 'Оставить заявку',
  [DEVICE_BUTTON_TYPE.outOfStockSent]: 'Повторить заявку',
};

export const deviceCardPurchaseButtonDataHelper = ({
  isInBasket = false,
  isPreorder = false,
  isOutOfStock = false,
  isOutOfStockSent = false,
}) => {
  let type = DEVICE_BUTTON_TYPE.toBasket;

  if (isInBasket) {
    type = DEVICE_BUTTON_TYPE.inBasket;
  }

  if (isPreorder) {
    type = DEVICE_BUTTON_TYPE.preOrder;
  }

  if (isOutOfStock) {
    type = DEVICE_BUTTON_TYPE.outOfStock;
  }

  if (isOutOfStock && isOutOfStockSent) {
    type = DEVICE_BUTTON_TYPE.outOfStockSent;
  }

  return {
    variant: DEVICE_BUTTON_VARIANT[type],
    title: DEVICE_BUTTON_CAPTION[type],
  };
};
